// Post-Authentication Request

/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

import { IQueryStringState } from '../../contexts/queryString/types';

export type IPostAuthenticationRequestsState = IPostAuthenticationRequest[];
export type PostAuthenticationRequestType = 'page' | 'checkout' | 'createProject' | 'joinProject' | 'downloadTrack';
export type PostAuthenticationRequest =
  | IPostAuthenticationDownloadTrackRequestActionPayload
  | IPostAuthenticationCreateProjectRequestActionPayload
  | IPostAuthenticationJoinProjectRequestActionPayload
  | null;

export interface IPostAuthenticationRequest {
  requestedAt: string;
  requestType: PostAuthenticationRequestType;
  payload?:
  | IPostAuthenticationDownloadTrackRequestActionPayload
  | IPostAuthenticationCreateProjectRequestActionPayload
  | IPostAuthenticationJoinProjectRequestActionPayload;
  page?: string;
}

export interface IPostAuthenticationRequestsActionPayload {
  postAuthenticationRequests: IPostAuthenticationRequest[];
}

export interface IPostAuthenticationRequestActionPayload {
  page?: string;
}

export interface IPostAuthenticationDownloadTrackRequestActionPayload extends IPostAuthenticationRequestActionPayload {
  path: string;
  track: GQL.ITrackSearchResult;
}

export interface IPostAuthenticationCreateProjectRequestActionPayload extends IPostAuthenticationRequestActionPayload {
  projectName: string;
  trackId: string;
  trackVersion: string;
  searchState: IQueryStringState;
}

export interface IPostAuthenticationJoinProjectRequestActionPayload extends IPostAuthenticationRequestActionPayload {
  projectOpaqueId: string;
}

const actionCreator = actionCreatorFactory('PostAuthenticationRequests');

export const recoverPostAuthenticationRequests = actionCreator<IPostAuthenticationRequest[]>('RECOVER');
export const pushPostAuthenticationRequestPage = actionCreator<IPostAuthenticationRequestActionPayload>('PUSH_PAGE_REQUEST');
export const pushPostAuthenticationRequestDownload = actionCreator<IPostAuthenticationDownloadTrackRequestActionPayload>('PUSH_DOWNLOAD_REQUEST');
export const pushPostAuthenticationRequestCreateProject = actionCreator<IPostAuthenticationCreateProjectRequestActionPayload>('PUSH_CREATE_PROJECT_REQUEST');
export const pushPostAuthenticationRequestJoinProject = actionCreator<IPostAuthenticationJoinProjectRequestActionPayload>('PUSH_JOIN_PROJECT_REQUEST');
export const consumePostAuthenticationRequests = actionCreator('CONSUME');
export const clearPostAuthenticationRequests = actionCreator('CLEAR');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/postAuthenticationRequests.ts